import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Camera, ArrowRight, Expand } from 'lucide-react';
import { GALLERY_GRID_ITEMS } from '../data/siteGallery';

const Gallery = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="gallery-page">
      {/* Hero Section */}
      <section className="relative bg-brand-950 py-24 overflow-hidden">
        <div className="absolute inset-0 industrial-grid opacity-20"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-brand-950"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          <div className="inline-flex items-center px-4 py-1.5 rounded-full bg-brand-500/10 border border-brand-400/30 text-brand-300 text-xs font-bold uppercase tracking-widest mb-6 backdrop-blur-md">
            Visual Excellence
          </div>
          <h1 className="font-heading text-4xl md:text-6xl font-extrabold text-white tracking-tight mb-6">
            Our Project <span className="text-brand-400">Gallery</span>
          </h1>
          <p className="max-w-2xl mx-auto text-lg text-neutral-300 font-light leading-relaxed">
            Explore our portfolio of high-performance industrial flooring installations across various sectors.
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {GALLERY_GRID_ITEMS.map((image) => (
              <div 
                key={image.url} 
                className="group relative rounded-large overflow-hidden shadow-custom hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 cursor-pointer"
              >
                <div className="aspect-w-16 aspect-h-12 w-full overflow-hidden">
                  <img 
                    src={image.url} 
                    alt={image.title} 
                    className="w-full h-80 object-cover transform group-hover:scale-110 transition-transform duration-700" 
                  />
                </div>
                
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-brand-950/90 via-brand-950/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col justify-end p-8">
                  <span className="text-brand-400 text-xs font-bold uppercase tracking-widest mb-2 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500 delay-100">
                    {image.category}
                  </span>
                  <h3 className="text-white font-heading text-xl font-bold mb-4 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500 delay-200">
                    {image.title}
                  </h3>
                  <div className="flex items-center text-white/70 text-sm font-medium transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500 delay-300">
                    View Project <Expand className="ml-2 w-4 h-4" />
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-20 text-center">
            <div className="bg-neutral-50 rounded-large p-10 border border-neutral-200">
              <Camera className="w-12 h-12 text-brand-900 mx-auto mb-4" />
              <h3 className="font-heading text-2xl font-bold text-neutral-900 mb-2">Want to see more?</h3>
              <p className="text-neutral-600 mb-8 max-w-xl mx-auto">
                We have completed 500+ projects across India. Contact us for sector-specific case studies and detailed site inspections.
              </p>
              <Link to="/contact" className="inline-flex items-center justify-center px-8 py-3.5 bg-brand-900 text-white font-bold rounded-small hover:bg-brand-800 transition-all shadow-custom">
                Request Case Study <ArrowRight className="ml-2 w-5 h-5" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;
